import React from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Store, LogOut, Gift, Images } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/admin", label: "Panou", icon: LayoutDashboard, end: true },
  { to: "/admin/produse", label: "Produse", icon: Package },
  { to: "/admin/oferte", label: "Oferte", icon: Gift },
  { to: "/admin/galerie", label: "Galerie", icon: Images },
  { to: "/admin/comenzi", label: "Comenzi", icon: ShoppingBag },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-slate-50" data-testid="admin-layout">
      <aside className="hidden w-64 shrink-0 flex-col border-r border-slate-200 bg-white md:flex">
        <Link to="/" className="flex items-center gap-2 border-b border-slate-100 px-6 py-5">
          <img src="/logo-icon.png" alt="Mimaso" className="h-9 w-auto" />
          <span className="font-display text-xl font-black text-slate-900">mimaso</span>
          <span className="ml-1 rounded bg-slate-900 px-1.5 py-0.5 text-[10px] font-bold uppercase text-white">Admin</span>
        </Link>
        <nav className="flex-1 space-y-1 p-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`admin-nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors",
                  isActive ? "bg-sky-600 text-white" : "text-slate-600 hover:bg-slate-100"
                )
              }
            >
              <item.icon className="h-4 w-4" /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-1 border-t border-slate-100 p-4">
          <Link to="/" className="flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-100">
            <Store className="h-4 w-4" /> Vezi magazinul
          </Link>
          <button onClick={() => { logout(); navigate("/"); }} className="flex w-full items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-semibold text-red-500 hover:bg-red-50" data-testid="admin-logout">
            <LogOut className="h-4 w-4" /> Deconectare
          </button>
        </div>
      </aside>

      <div className="flex-1">
        <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-4 md:hidden">
          <span className="font-display text-lg font-black">Admin Mimaso</span>
          <button onClick={() => { logout(); navigate("/"); }} className="text-red-500"><LogOut className="h-5 w-5" /></button>
        </header>
        <div className="flex gap-1 overflow-x-auto border-b border-slate-200 bg-white px-4 py-2 md:hidden">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => cn("whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-semibold", isActive ? "bg-sky-600 text-white" : "text-slate-600")}>
              {item.label}
            </NavLink>
          ))}
        </div>
        <main className="p-6 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
